import posthog from 'posthog-js';
import { POSTHOG_API_HOST } from '@/common';

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: POSTHOG_API_HOST,
  ui_host: 'https://us.posthog.com',
  defaults: '2025-05-24',
  capture_exceptions: true, // This enables capturing exceptions using Error Tracking
  autocapture: false,
});
